// The game renders with roundPixels, which floors every sprite's own x/y: something drifting
// a few px a second then moves in visible one-pixel steps. A Container's transform is not
// floored (phaser/src/gameobjects/container/ContainerWebGLRenderer.js), so a slow mover sits
// at (0, 0) inside one and the CONTAINER is what the caller moves.
export function subpixel(scene, child, depth) {
  return scene.add.container(0, 0, [child]).setScrollFactor(0).setDepth(depth);
}
